import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import ROUTES from 'consts/routes';
import RiskSummaryPage from 'pages/RiskSummary/RiskSummary';
import ManagePolicies from 'pages/ExistingPolicies/ManagePolicies';
import Recommendations from 'pages/Recommendations/Recommendations';
import AdvisorChargesV2 from 'pages/AdviserCharges_v2/AdviserCharges_v2';
import PolicyAnalysis from 'pages/ExistingPolicies/PolicyAnalysis';
import IPS from 'pages/IPS/IPS';
import PortfolioBuilder from 'pages/PortfolioBuilder/PortfolioBuilder';
import CapacityForLossQuestionnairePage from 'pages/CapacityForLossQuestionnaire/CapacityForLossQuestionnaire';
import ExperienceQuestionnairePage from 'pages/ExperienceQuestionnaire/ExperienceQuestionnaire';
import ProtectedRoute from './ProtectedRoute';
import EditCase from 'pages/Case/EditCase';
import IPSPrint from 'pages/IPS/Printer';
import QuestionnairePage from 'pages/Questionnaire/Questionnaire';
import QuestionairePage from 'pages/CustomerQuestionnaire/QuestionairePage';
import actions from 'store/actions';
import { connect } from 'react-redux';
import { compose } from 'redux-starter-kit';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';
import RiskMapping from 'pages/RiskMapping/RiskMapping';
import api from 'api';
import CipManagmentPage from 'pages/CIpManagement/CipManagementPage';
import ProviderPlatformChargesPage from 'pages/ProviderPlarformCharges/ProviderPlatformCharges';
import CasePage from 'pages/Case/CasePage';
import Homepage from 'pages/Homepage/Homepage';
import SettingsPage from 'pages/Settings/Settings';
import InvestmentAnalyserPage from 'pages/InvestmentAnalyser/InvestmentAnalyserPage';
import UserSettingsPage from 'pages/UserSettings/UserSettings';
import selectors from 'store/selectors';
import LoginPage from 'pages/Login/Login';
import PasswordResetPage from 'pages/PasswordReset/PasswordReset';
import GlossaryPage from 'pages/Glossary/GlossaryPage';
import MpsHubPage from 'pages/MpsHub/MpsHub';
import MpsHubProviderPage from 'pages/MpsHub/MpsHubProvider';
import MpsHubProviderEditPage from 'pages/MpsHub/MpsHubProviderEdit';
import TrialExpired from 'pages/TrialExpired/TrialExpired';

const Routes = ({
  getAdvisorDetails,
  setFirmConfig,
  advisor,
  startWebSocket
}: any) => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    /* eslint-disable   react-hooks/exhaustive-deps */
    if (isAuthenticated) {
      startWebSocket();
      getAdvisorDetails();
    }
  }, [isAuthenticated]);
  /* eslint-enable   react-hooks/exhaustive-deps */

  useEffect(() => {
    api.getFirmConfig().then(config => {
      setFirmConfig(config);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advisor]);

  return (
    <Switch>
      <Route exact path={ROUTES.LOGIN} component={LoginPage} />
      <Route exact path={ROUTES.PASSWORD_RESET} component={PasswordResetPage} />
      <ProtectedRoute
        exact
        path={ROUTES.TRIAL_EXPIRED}
        component={TrialExpired}
      />
      <ProtectedRoute exact path={ROUTES.CASES} component={CasePage} />
      <ProtectedRoute exact path={ROUTES.HOMEPAGE} component={Homepage} />
      <ProtectedRoute exact path={ROUTES.CASE.EDIT} component={EditCase} />
      <Route exact path={ROUTES.SURVEY} component={QuestionairePage} />
      <ProtectedRoute
        path={ROUTES.RISK_SUMMARY.MAIN}
        component={RiskSummaryPage}
        exact
      />
      {/* EXISTING POLICIES */}
      <Redirect
        from={ROUTES.EXISTING_POLICIES.MAIN}
        to={ROUTES.EXISTING_POLICIES.MANAGE_POLICIES}
        exact
      />
      {/* QESTIONNAIRE */}
      <ProtectedRoute
        exact
        path={ROUTES.QUESTIONNAIRE.MAIN}
        component={QuestionnairePage}
      />

      <ProtectedRoute
        exact
        path={ROUTES.EXISTING_POLICIES.MANAGE_POLICIES}
        component={ManagePolicies}
      />

      <ProtectedRoute
        exact
        path={ROUTES.EXISTING_POLICIES.POLICY_ANALYSIS}
        component={PolicyAnalysis}
      />

      <ProtectedRoute
        exact
        path={ROUTES.RECOMMENDATIONS.MAIN}
        component={Recommendations}
      />
      <ProtectedRoute
        exact
        path={ROUTES.RECOMMENDATIONS.PORTFOLIO_BUILDER}
        component={PortfolioBuilder}
      />
      <ProtectedRoute
        exact
        path={ROUTES.ADVISOR_CHARGES.MAIN}
        component={AdvisorChargesV2}
      />
      <ProtectedRoute exact path={ROUTES.IPS.MAIN} component={IPS} />
      <ProtectedRoute exact path={ROUTES.IPS.PRINT} component={IPSPrint} />
      <ProtectedRoute
        exact
        path={ROUTES.RISK_MAPPING}
        component={RiskMapping}
      />
      <ProtectedRoute
        exact
        path={ROUTES.CIP_MANAGEMENT}
        component={CipManagmentPage}
      />
      <ProtectedRoute
        exact
        path={ROUTES.PROVIDER_PLATFORM_CHARGES}
        component={ProviderPlatformChargesPage}
      />
      <ProtectedRoute
        exact
        path={ROUTES.CFL_QUESTIONNAIRE}
        component={CapacityForLossQuestionnairePage}
      />
      <ProtectedRoute
        exact
        path={ROUTES.EXP_QUESTIONNAIRE}
        component={ExperienceQuestionnairePage}
      />
      <ProtectedRoute exact path={ROUTES.SETTINGS} component={SettingsPage} />
      <ProtectedRoute
        exact
        path={ROUTES.INVESTMENT_ANALYSER}
        component={InvestmentAnalyserPage}
      />
      <ProtectedRoute exact path={ROUTES.GLOSSARY} component={GlossaryPage} />
      <ProtectedRoute
        exact
        path={ROUTES.USER_SETTINGS}
        component={UserSettingsPage}
      />
      <ProtectedRoute exact path={ROUTES.MPS_HUB.BASE} component={MpsHubPage} />
      <ProtectedRoute
        exact
        path={ROUTES.MPS_HUB.PROVIDER}
        component={MpsHubProviderPage}
      />
      <ProtectedRoute
        exact
        path={ROUTES.MPS_HUB.PROVIDER_EDIT}
        component={MpsHubProviderEditPage}
      />
      <Redirect from="*" to={ROUTES.HOMEPAGE} />
    </Switch>
  );
};

export default compose(
  connect(
    (state: any) => ({
      advisor: selectors.advisorSelectors.getAdvisor(state)
    }),
    {
      startWebSocket: actions.webSocketActions.startWebsocketConnection,
      getAdvisorDetails: actions.AdvisorActions.getAdvisor,
      setFirmConfig: actions.firmActions.setFirmConfig
    }
  )
)(Routes);
